import styled from 'styled-components'

const DatasetContainer = styled.div`
  background-color: ${(props) => props.theme.logoBg};
  color: ${(props) => props.theme.panelBgLight};
  padding: 8px 16px 0;
`

export default DatasetContainer
